import { TableInstance } from 'react-table';
import { RenderRowFunction } from '../../../../../ui/Table/Table';
import styles from './PostStatsTable.module.css';
import range from 'lodash/range';
import { Skeleton } from '@round/ui-kit';
import cn from 'classnames';
import { TiktokPostStatsTableRow } from './TiktokPostStatsTable';
import { InstagramPostStatsTableRow } from './InstagramPostStatsTable';
import { statusOrder } from '../../../../../utils/constants';

export const renderPostStatsTableBody =
    (loading: boolean, error: boolean) =>
    ({ rows, prepareRow, columns }: TableInstance<any>, renderRow: RenderRowFunction<any>) => {
        const displayNoDataLabel = !loading && !rows.length;

        if (error) {
            return (
                <tr>
                    <td colSpan={columns.length} className={cn(styles.message, styles.error)}>
                        Error loading data
                    </td>
                </tr>
            );
        }

        if (displayNoDataLabel) {
            return (
                <tr>
                    <td colSpan={columns.length} className={cn(styles.message, styles.noData)}>
                        No results yet
                    </td>
                </tr>
            );
        }

        return (
            <>
                {loading
                    ? range(0, 6).map((i) => (
                          <tr key={i}>
                              {columns.map((column) => (
                                  <td key={column.id}>
                                      <Skeleton style={{ zIndex: 'unset' }} />
                                  </td>
                              ))}
                          </tr>
                      ))
                    : rows.map((row) => {
                          prepareRow(row);
                          return renderRow(row);
                      })}
            </>
        );
    };

export const sortTiktokPostStatsTableRows = (a: TiktokPostStatsTableRow, b: TiktokPostStatsTableRow) => {
    const orderByStatus = statusOrder[a.booking.status] - statusOrder[b.booking.status];
    const orderByViews = (b.play_count || 0) - (a.play_count || 0);

    if (orderByStatus !== 0) {
        return orderByStatus;
    }
    return orderByViews;
};

export const sortInstagramPostStatsTableRows = (a: InstagramPostStatsTableRow, b: InstagramPostStatsTableRow) => {
    const orderByStatus = statusOrder[a.booking.status] - statusOrder[b.booking.status];
    const orderByViews = (b.total_views || 0) - (a.total_views || 0);

    if (orderByStatus !== 0) {
        return orderByStatus;
    }
    return orderByViews;
};
